import { createApp } from "vue";
import axios from "axios";

export const configCsrfToAxios = () => {
  // 設定 CSRF token
  const csrfToken = document.querySelector('meta[name="csrf-token"]');
  if (csrfToken) {
    axios.defaults.headers.common["X-CSRF-Token"] =
      csrfToken.getAttribute("content");
  }
};

// 將 pageScope 設為所有 axios request 的預設 header
// 後端 controller 可從 `X-Page-Scope` header 取得當前頁面所屬的 scope
// (admin / country / member / main)
export const configPageScopeToAxios = (pageScope) => {
  if (!pageScope) return;
  axios.defaults.headers.common["X-Page-Scope"] = pageScope;
};

export const initializeInstances = ({
  pinia,
  i18n,
  vueApps,
  importInitializer,
  pageScope,
}) => {
  configPageScopeToAxios(pageScope);

  const mountAll = () => {
    const templates = document.querySelectorAll("[data-vue]");

    templates.forEach(async (template) => {
      try {
        const vueName = template.dataset.vue;
        const initializer = await importInitializer(vueName);

        const app = createApp(initializer.default);
        app.use(pinia);
        if (i18n) app.use(i18n);
        if (pageScope) app.provide("pageScope", pageScope);
        app.mount(template, true);

        vueApps.push(app);
      } catch (err) {
        console.error(`❌ Failed to initialize ${template.dataset.vue}:`, err);
      }
    });
  };

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", mountAll);
  } else {
    mountAll();
  }
};
